(function ($) {

'use strict';

	/**
	 * load a image file from slider
	 */
	$.fn.loadImage = function (config) {
		if ($(this).length < 1) {
			return 0;
		}

		var options = $.extend({
			containerSelector: '.image-slider-container',
			imgLinkSelector: '.image-slider .imglink',
			imageSelector: '.active-image-container img'
		}, (config || {}));

		var $sliderContainer = $(this).closest(options.containerSelector);
		var image = $sliderContainer.find(options.imageSelector)[0];
		var $imagesrc = $(this).find('img').attr('src');

		if (image && $imagesrc !== $sliderContainer.find(options.imageSelector).attr('src')) {
			$sliderContainer.find(options.imgLinkSelector).removeClass('active');
			$(this).find('.imglink').addClass('active');

			var iTitle = '';
			var $title = $(this).find('figcaption');
			if ($title.length > 0) {
				iTitle = $title.html();
			} else {
				// fallback for old container structure without <figure> elements
				$(this).first().children('p').each(function () {
					iTitle += '<p>' + $(this).html() + '</p>';
				});
			}
			$sliderContainer.find('.ititle').not('.gtitle').html(iTitle);

			$sliderContainer.find(options.imageSelector).fadeOut(500, function () {
				$(this).attr('src', $imagesrc).fadeIn();
			});
			// alternate transition			
			//		$(options.imageSelector).fadeTo(300, 0.2, 'linear', function(){
			//			$(this).attr('src', $imagesrc).fadeTo(500, 1, 'linear');
			//		});
		}
	};	//$.fn.loadImage

}(jQuery));